import { Card, DropDownArrowIcon, Htag } from "components";
import { IOption, ISummary } from "store/caseStudy/caseStudy.interface";
import ReactHtmlParser from "html-react-parser";
import s from "./OptionsWidget.module.css";
import { useState } from "react";

const optionsIcons = [
  {
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="104"
        height="64"
        viewBox="0 0 104 64"
        fill="none"
      >
        <path
          d="M31.5009 63.1797C48.8979 63.2787 63.0812 49.2559 63.1801 31.859C63.2791 14.462 49.2564 0.278709 31.8594 0.179722C14.4624 0.0807338 0.27913 14.1035 0.180142 31.5005C0.081154 48.8975 14.1039 63.0807 31.5009 63.1797Z"
          fill="#4EB072"
        />
        <path
          d="M71.4697 31.9063C71.3707 49.3025 85.3942 63.4865 102.79 63.5855L103.149 0.585483C85.7527 0.486499 71.5687 14.51 71.4697 31.9063Z"
          fill="#DEAD7F"
        />
      </svg>
    ),
  },
  {
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="198"
        height="63"
        viewBox="0 0 198 63"
        fill="none"
      >
        <path
          d="M149.949 63.0003L149.949 2.42334L180.18 32.7118L149.949 63.0003Z"
          fill="#91CCD1"
        />
        <path
          d="M119.717 63.0003L119.717 2.42334L149.948 32.7118L119.717 63.0003Z"
          fill="#91CCD1"
        />
        <path
          d="M89.3719 63.0003C106.068 63.0003 119.603 49.4397 119.603 32.7118C119.603 15.9839 106.068 2.42334 89.3719 2.42334C72.6755 2.42334 59.1404 15.9839 59.1404 32.7118C59.1404 49.4397 72.6755 63.0003 89.3719 63.0003Z"
          fill="#FAB39D"
        />
        <path
          d="M29.0222 32.4099C29.0222 48.9703 42.4231 62.3965 58.9524 62.3965L58.9524 2.42334C42.4231 2.42334 29.0222 15.8494 29.0222 32.4099Z"
          fill="#0999B9"
        />
        <path
          d="M0 32.4099C0 48.9703 13.4009 62.3965 29.9302 62.3965L29.9302 2.42334C13.4009 2.42334 0 15.8494 0 32.4099Z"
          fill="#0999B9"
        />
        <path
          d="M168.087 15.3183C169.163 14.9894 168.542 14.1234 168.608 13.5205C168.675 12.8847 168.753 12.6107 169.518 12.5559C171.693 12.4024 173.767 12.8957 175.809 13.4328C176.785 13.685 176.43 13.0163 176.364 12.8409C175.853 11.4158 175.432 9.92501 174.688 8.60958C173.634 6.74604 173.723 4.64134 173.091 2.70107C172.991 2.41606 172.924 1.72546 173.279 1.74738C174.633 1.857 174 -0.10519 175.287 0.00442992C175.731 0.0482778 176.131 0.00442991 176.53 0.377137C176.896 0.72792 176.785 1.26506 177.107 1.50622C177.972 2.15298 177.151 3.20533 177.817 3.98363C178.261 4.49884 178.538 5.27714 178.66 6.08832C178.838 7.31606 179.37 8.51092 179.858 9.68385C180.003 10.0237 180.724 9.93598 180.735 9.62904C180.757 7.82031 182.532 7.10779 183.154 5.68273C183.497 4.90443 184.674 4.66327 184.718 3.57803C184.729 3.32591 185.151 3.1834 185.395 3.30398C186.005 3.61092 186.593 3.98363 187.159 4.36729C187.503 4.5975 187.503 4.91539 187.381 5.29906C187.092 6.19794 184.718 10.506 184.052 11.3172C183.664 11.7776 183.076 12.0407 182.976 12.808C182.921 13.2355 181.933 13.7727 182.022 13.959C182.288 14.5071 182.998 14.1344 183.509 14.2331C184.185 14.3646 184.851 15.406 185.539 14.244C186.127 15.1319 187.048 14.6277 187.802 14.7812C190.576 15.3512 193.427 15.2635 196.201 15.8335C196.745 15.9431 197 16.6009 197.632 16.4364C197.71 16.4145 197.932 16.6447 197.965 16.7872C198.176 17.7957 197.366 18.5411 197.266 19.5167C197.211 20.0758 196.423 20.4047 195.702 20.2512C194.759 20.0429 193.682 20.7006 192.839 19.8237C192.784 19.7689 192.684 19.7141 192.617 19.7141C191.419 19.7141 190.21 19.5935 189.023 19.736C187.802 19.8894 186.881 18.7494 185.65 19.155C185.406 19.2317 185.006 19.144 184.895 19.2865C184.563 19.736 185.195 19.7689 185.328 20.0429C185.894 21.183 186.526 22.2901 187.07 23.4302C187.791 24.921 187.547 25.8199 186.293 26.6091C185.461 27.1353 184.318 26.8503 183.464 25.8637C182.787 25.0745 181.966 24.3181 181.589 23.3973C181.168 22.3669 179.969 21.753 180.091 20.4266C180.114 20.2402 179.792 19.6702 179.57 19.3085C179.071 18.5302 178.693 18.5959 178.039 19.44C176.696 21.172 175.298 22.8711 173.945 24.6031C173.523 25.1402 173.268 25.0525 172.713 24.7018C172.392 24.5044 171.981 24.2962 171.604 24.0879C170.849 23.6823 170.528 23.0136 171.06 22.5861C172.159 21.6982 171.937 20.0977 173.068 19.2865C172.902 18.4754 174.333 18.3438 173.923 17.6751C173.734 17.3792 172.736 17.5326 172.103 17.5436C170.517 17.5765 169.307 16.7324 168.087 15.8993V15.3512V15.3183Z"
          fill="#102D3E"
        />
      </svg>
    ),
  },
  {
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="161"
        height="106"
        viewBox="0 0 161 106"
        fill="none"
      >
        <path
          d="M161 48.4995C161 64.239 149.359 76.9995 135 76.9995V19.9995C149.359 19.9995 161 32.76 161 48.4995Z"
          fill="#FAB39D"
        />
        <path
          d="M27.0687 19.7716L81.2062 77.2569L27.0687 77.2569L27.0687 19.7716Z"
          fill="#91CCD1"
        />
        <path
          d="M80.8937 19.7716L135.031 77.2569L80.8937 77.2569L80.8937 19.7716Z"
          fill="#4EB072"
        />
        <path
          d="M66.1215 32.9192C66.8134 33.2454 67.6877 33.4299 67.2852 34.607C68.1365 36.1127 68.0354 37.4946 67.4184 39.1926C66.8414 40.7745 66.472 42.4642 65.8626 44.0571C65.6655 44.5645 65.6847 45.1729 65.6571 45.7327C65.6535 45.863 65.8432 46.0414 65.9907 46.1392C66.2088 46.2813 66.328 46.2028 66.3392 45.9674C66.4371 44.2905 68.5363 44.8969 68.8724 43.4881C70.2622 43.2011 70.857 41.7611 71.9693 41.0523C73.1163 40.3165 74.1194 39.3525 75.2433 38.5638C76.3087 37.8064 77.1562 36.6942 78.6216 36.575C79.3393 36.5129 79.3792 35.0227 80.4364 35.2209C83.1503 33.3519 86.0276 31.8942 89.2112 31.1902C90.7661 29.7689 92.865 30.0073 94.6371 29.2105C96.2859 28.4671 98.1433 28.1423 99.9335 27.8556C103.764 27.2578 107.632 26.9851 111.502 27.1217C112.115 27.1407 112.702 26.8689 113.262 26.9856C114.384 27.2188 115.58 26.5156 116.598 27.1408C117.561 27.7241 118.55 27.3796 119.501 27.5193C121.922 27.8661 125.301 27.7573 127.407 28.8668C127.859 29.0964 128.392 29.5602 128.777 29.4597C129.179 29.8939 129.179 34.1971 127.404 33.7C125.288 33.107 123.121 32.8084 121.01 32.4945C116.427 31.8073 111.773 31.4439 107.109 31.6839C104.688 31.8097 102.285 31.9632 99.8895 32.494C98.9096 32.7174 97.9273 32.9569 97.019 33.323C95.2174 34.0577 93.3317 34.4187 91.4743 34.7434C90.5725 34.9061 90.1753 35.9941 89.1123 35.7296C88.5991 35.6044 87.7448 35.7585 87.4727 36.6217C86.4091 36.4143 86.0031 37.7217 85.2009 37.8353C82.8481 38.1769 81.7037 40.8515 79.3498 41.0948C79.4207 42.3005 78.3753 41.8098 77.9664 42.1844C77.5205 42.6019 77.2591 43.0742 76.5552 43.2531C75.9075 43.4166 75.3046 44.0128 74.8314 44.5648C74.4607 44.9947 74.2137 45.5267 73.6707 45.7646C73.636 45.7916 73.6572 46.016 73.6248 46.027C72.5898 46.3641 71.9838 47.2461 71.2372 47.9822C70.3842 48.8154 69.3738 49.4592 68.4421 50.1977C68.1381 50.434 67.8677 50.545 67.4829 50.49C66.6531 50.3701 66.6363 51.1198 66.6956 51.6121C66.795 52.569 67.2471 51.58 67.5213 51.7068C67.6735 51.7727 67.8157 51.9596 67.9558 51.9499C68.8928 51.9157 69.0224 53.4582 70.2814 53.117C70.884 52.946 71.7121 53.8181 72.4752 54.1315C74.278 54.8692 76.0848 55.6321 77.9386 56.231C79.4383 56.7227 79.4516 56.684 79.7432 58.384C79.8584 59.0735 79.656 59.6701 79.6168 60.3097C79.5904 60.7553 79.3114 60.873 78.9039 60.9206C78.1729 61.0214 75.0972 60.7208 74.4018 60.3121C72.4118 59.1675 70.1917 58.5984 68.1356 57.5901C66.8421 56.9524 65.6575 55.989 64.3702 55.5732C62.1148 54.8756 61.4311 52.8004 60.1041 51.2821C59.5299 50.6235 59.6403 49.9709 59.6745 49.2077C59.7193 48.0537 60.2768 47.082 60.6149 46.0825C60.9397 45.1216 60.8966 43.9368 61.4209 43.2459C62.0894 42.3579 61.5048 40.8715 62.8125 40.4074C63.0244 40.3277 62.994 39.9546 62.8009 39.6939C62.4956 39.2512 62.6629 38.5262 62.854 38.3777C64.1308 37.385 64.0016 35.998 63.9413 34.614L66.1128 32.9259L66.1215 32.9192Z"
          fill="#102D3E"
        />
      </svg>
    ),
  },
];

export const OptionsWidgetUser = ({
  data,
}: {
  data: IOption[] | undefined[] | null[];
  mainTitle: string;
  summary: ISummary[];
}) => {
  const [activeIndex, setActiveIndex] = useState<number | null>(null);

  const toggle = (index: number | null): void => {
    setActiveIndex((prev) => (prev === index ? null : index));
  };
  return (
    <div className={s.optionsContainer}>
      <Htag tag="h2" className={s.cs_title}>
        Thinking through their options
      </Htag>
      <p style={{ fontWeight: "500" }}>
        There’s no precise answer and no “perfect” outcome. Here are three
        options this separating couple considered. Click to open and find out
        more about each options, including pros and cons of each.
      </p>
      <div className={s.optionsList}>
        {data.map((item, index) => (
          <Card className={s.optionsItem} key={index}>
            <div
              className={`${s.accordionTitleWrap} ${
                activeIndex === index && s.active
              }`}
              onClick={() => toggle(index)}
            >
              <div className={s.accordionTitle_top}>
                {optionsIcons[index].icon}{" "}
                {activeIndex === index ? (
                  <span className={s.accordionTitle_btn}>
                    Hide <DropDownArrowIcon className={s.down} />
                  </span>
                ) : (
                  <span className={s.accordionTitle_btn}>
                    Show <DropDownArrowIcon />
                  </span>
                )}
              </div>

              <Htag tag="h3" className={s.accordionTitle}>
                Option {index + 1}: {item?.title}
              </Htag>
            </div>

            <div className={`${s.dropdown} ${activeIndex === index && s.show}`}>
              <div className={s.content}>
                {item &&
                  typeof item.content == "string" &&
                  ReactHtmlParser(item.content)}
              </div>
              <Htag tag="h4">Pros</Htag>
              <ul>
                {item?.pros.map((listI, index) => (
                  <li key={index}>{listI}</li>
                ))}
              </ul>
              <Htag tag="h4">Cons</Htag>
              <ul>
                {item?.cons.map((listI, index) => (
                  <li key={index}>{listI}</li>
                ))}
              </ul>
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
};
